"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    /**
   * Adds query parameters to given url
   * @param url Url to which options will be added
   * @param options Query parameters to add
   */
    UrlHelper.prototype.addOptionsToUrl = function (url, options) {
        if (options) {
            options.forEach(function (filter) {
                if (url.indexOf('?') > -1) {
                    url = url + '&' + filter.getParam() + '=' + filter.getParamValue();
                }
                else {
                    url = url + '?' + filter.getParam() + '=' + filter.getParamValue();
                }
            });
        }
        return url;
    };
    return UrlHelper;
}());
exports.UrlHelper = UrlHelper;
exports.urlHelper = new UrlHelper();
//# sourceMappingURL=url.helper.js.map